export default "__VITE_ASSET__osrVGhhg__"